import { render, staticRenderFns } from "./Mostplays.vue?vue&type=template&id=54bad135&scoped=true"
import script from "./Mostplays.vue?vue&type=script&lang=js"
export * from "./Mostplays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bad135",
  null
  
)

export default component.exports